export default __webpack_public_path__ + "static/media/tickMark.03e05552.svg";